import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const deleteWallet = (name) => request.delete(`${API_BASE_URL}/blockchain/wallets/${encodeURI(name)}`)

export default deleteWallet;